// extracted by mini-css-extract-plugin
export var APFIPPprizes = "MutualFund-module--APFIPPprizes--9f450";
export var APFIPPprizesContainer = "MutualFund-module--APFIPPprizesContainer--d453b";
export var APFIPPprizesList = "MutualFund-module--APFIPPprizesList--15fec";
export var arrowUpAndDown = "MutualFund-module--arrow-up-and-down--9691a";
export var bar = "MutualFund-module--bar--bf990";
export var competentAuthorityContainer = "MutualFund-module--competentAuthorityContainer--05aa0";
export var competentAuthorityTitle = "MutualFund-module--competentAuthorityTitle--a287b";
export var container = "MutualFund-module--container--c65cd";
export var description = "MutualFund-module--description--68d03";
export var disclaimer = "MutualFund-module--disclaimer--a617a";
export var disclaimerLink = "MutualFund-module--disclaimerLink--bfc5d";
export var disclaimerModalContainer = "MutualFund-module--disclaimerModalContainer--f7c64";
export var disclaimerModalText = "MutualFund-module--disclaimerModalText--c0119";
export var disclaimerModalTitle = "MutualFund-module--disclaimerModalTitle--5cf0c";
export var fiveBarFill = "MutualFund-module--fiveBarFill--ffb4d";
export var fourBarFill = "MutualFund-module--fourBarFill--3bfdc";
export var investmentRiskBarsContainer = "MutualFund-module--investmentRiskBarsContainer--a3c1a";
export var investmentRiskLabels = "MutualFund-module--investmentRiskLabels--45600";
export var investmentRiskTitle = "MutualFund-module--investmentRiskTitle--70836";
export var metric = "MutualFund-module--metric--aaf31";
export var metricsContainer = "MutualFund-module--metricsContainer--df120";
export var metricsWrapper = "MutualFund-module--metricsWrapper--ad815";
export var morningstarImageContainer = "MutualFund-module--morningstarImageContainer--49e7c";
export var oneBarFill = "MutualFund-module--oneBarFill--8f046";
export var otherPrize = "MutualFund-module--otherPrize--2e8cc";
export var otherPrizesContainer = "MutualFund-module--otherPrizesContainer--a0c5d";
export var otherPrizesImagesContainer = "MutualFund-module--otherPrizesImagesContainer--b3de1";
export var prizeLogoContainer = "MutualFund-module--prizeLogoContainer--28673";
export var prizesSection = "MutualFund-module--prizesSection--80194";
export var prizesTextWithoutBackground = "MutualFund-module--prizesTextWithoutBackground--6c4e8";
export var prizesTitle = "MutualFund-module--prizesTitle--044f4";
export var ratingAndMorningstarContainer = "MutualFund-module--ratingAndMorningstarContainer--18000";
export var ratingContainer = "MutualFund-module--ratingContainer--4f14c";
export var sevenBarFill = "MutualFund-module--sevenBarFill--c606e";
export var sixBarFill = "MutualFund-module--sixBarFill--8e78f";
export var threeBarFill = "MutualFund-module--threeBarFill--8d9bd";
export var twoBarFill = "MutualFund-module--twoBarFill--1ba71";
export var valuesUpdateDate = "MutualFund-module--valuesUpdateDate--eda6a";
export var valuesUpdateInfo = "MutualFund-module--valuesUpdateInfo--12496";
export var valuesUpdateText = "MutualFund-module--valuesUpdateText--da589";